<h2 mat-dialog-title>{{ data.entityLabel }} translations</h2>

<mat-dialog-content class="translation-dialog-content">
  <form [formGroup]="form" class="translation-form">
    @for (lang of data.languages; track lang.id) {
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ lang.name }} ({{ lang.locale }})</mat-label>
        <input matInput [formControlName]="lang.locale" />

        @if (form.get(lang.locale)?.touched && form.get(lang.locale)?.hasError('required')) {
          <mat-error>Translation is required</mat-error>
        }
      </mat-form-field>
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" type="button" (click)="save()">Save</button>
</mat-dialog-actions>
